<template>
  <div class="tag">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AdnTag',
  props: {
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
    borderColor: {
      type: String,
      default: 'black',
    },
    borderStyle: {
      type: String,
      default: 'solid',
    },
    textColor: {
      type: String,
      default: 'black',
    },
    shape: {
      type: String,
      default: '3rem',
    },
    fontSize: {
      type: String,
      default: 'var(--font-size-s)',
    },
    fontWeight: {
      type: String,
      default: 'normal',
    },
  },
})
</script>

<style lang="scss">
.tag {
  padding: var(--spacing-2) var(--spacing-3);
  margin: 0.1rem 0;
  border-width: 0.1rem;
  border-style: v-bind(borderStyle);
  border-color: v-bind(borderColor);
  border-radius: v-bind(shape);
  font-weight: v-bind(fontWeight);
  font-size: v-bind(fontSize);
  color: v-bind(textColor);
  background-color: v-bind(backgroundColor);
  white-space: nowrap;
}
</style>
